var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.558 11.469l-5.04-4.973a2.54 2.54 0 00-1.798-.736h-6.48a2.563 2.563 0 00-2.56 2.56v15.36a2.563 2.563 0 002.56 2.56h11.52a2.563 2.563 0 002.56-2.56V13.29c0-.679-.279-1.344-.762-1.821zm-.899.912c.122.121.218.265.282.419H18.56a1.28 1.28 0 01-1.28-1.28V7.174c.121.061.237.135.34.234l5.04 4.973zm-.9 12.579H10.24a1.28 1.28 0 01-1.28-1.28V8.32c0-.707.574-1.28 1.28-1.28H16v4.48a2.563 2.563 0 002.56 2.56h4.48v9.6a1.28 1.28 0 01-1.28 1.28z",
    fill: "#fff"
  })));
}

export default SvgFileinline;